import React, { useEffect, useState } from "react";

import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

import funkcionalnostAplikacije from "../../../assets/img/common/png/funkcionalnostAplikacije.png";
import infoODobitku from "../../../assets/img/common/png/infoODobitku.png";
import izvlacenje from "../../../assets/img/common/png/izvlacenje.png";
import odabirBrojevaIUlog from "../../../assets/img/common/png/odabirBrojevaIUlog.png";
import pokretanjeIzvlacenja from "../../../assets/img/common/png/pokretanjeIzvlacenja.png";
import tabelaBrojevaIUloga from "../../../assets/img/common/png/tabelaBrojevaIUloga.png";
import undoBet from "../../../assets/img/common/png/undoBet.png";
import close from "../../../assets/img/common/close.svg";

interface Props {
  closeModal: () => void;
}

const ModalMessage: React.FC<Props> = ({ closeModal }) => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = (): void => {
    setIsVisible(false);
    setTimeout(() => {
      closeModal();
    }, 500);
  };

  useEffect(
    () => () => {
      setIsVisible(true);
    },
    []
  );

  return createPortal(
    <div
      className="backdrop"
      role="presentation"
      onClick={(e) => {
        e.stopPropagation();
        handleClose();
      }}
      onKeyDown={(e) => {
        e.stopPropagation();
        if (e.key === "Enter") handleClose();
      }}
    >
      <div
        className={`modal_container rules_modal_container ${
          isVisible ? "fade-in" : "fade-out"
        }`}
        onClick={(e) => {
          e.stopPropagation();
        }}
        role="presentation"
      >
        <button
          type="button"
          className="close_modal_btn"
          onClick={() => {
            handleClose();
          }}
        >
          <img src={close} alt="Close" className="close_modal" />
        </button>

        <div className="rules_content">
          <h3>{t("rules.generalDescriptionTitle")}</h3>
          <p>{t("rules.generalDescriptionParagraph1")}</p>
          <p>{t("rules.generalDescriptionParagraph2")}</p>
          <p>{t("rules.generalDescriptionParagraph3")}</p>

          <h3>{t("rules.descriptionTitle")}</h3>
          <p>{t("rules.descriptionParagraph1")}</p>

          <h3>{t("rules.functionalityTitle")}</h3>

          <img
            src={funkcionalnostAplikacije}
            alt="Funkcionalnost aplikacije"
            className="rules_img"
          />
          <span>{t("rules.functionalityImage")}</span>
          <p>{t("rules.functionalityParagraph1")}</p>
          <ol>
            <li>{t("rules.functionalityList1")}</li>
            <li>{t("rules.functionalityList2")}</li>
            <li>{t("rules.functionalityList3")}</li>
            <li>{t("rules.functionalityList4")}</li>
            <li>{t("rules.functionalityList5")}</li>
            <li>{t("rules.functionalityList6")}</li>
            <li>{t("rules.functionalityList7")}</li>
            <li>{t("rules.functionalityList8")}</li>
          </ol>

          <h3>{t("rules.selectionTitle")}</h3>
          <div className="rules_img_cont">
            <img src={odabirBrojevaIUlog} alt="Odabir brojeva i ulog" />
            <span>{t("rules.selectionImage")}</span>
          </div>
          <p>{t("rules.selectionParagraph")}</p>
          <ol>
            <li>
              {t("rules.selectionList1")}
              <ol>
                <li>{t("rules.selectionSublist1")}</li>
                <li>{t("rules.selectionSublist2")}</li>
              </ol>
            </li>
            <li>{t("rules.selectionList2")}</li>
          </ol>

          <h3>{t("rules.playTitle")}</h3>
          <div className="rules_img_cont">
            <img src={undoBet} alt="Undo Bet" />
            <span>{t("rules.playImage1")}</span>
          </div>

          <p>{t("rules.playParagraph")}</p>
          <div className="rules_img_cont">
            <img src={izvlacenje} alt="izvlačenje" />
            <span>{t("rules.playImage2")}</span>
          </div>
          <ol>
            <li>{t("rules.playList1")}</li>
            <li>{t("rules.playList2")}</li>
            <li>{t("rules.playList3")}</li>
            <li>{t("rules.playList4")}</li>
            <li>{t("rules.playList5")}</li>
          </ol>

          <h3>{t("rules.howToTitle")}</h3>
          <p>{t("rules.howToParagraph")}</p>
          <ol>
            <li>{t("rules.howToList1")}</li>
            <li>{t("rules.howToList2")}</li>
            <li>
              {t("rules.howToList3")}
              <ol>
                <li>{t("rules.howToSublist1")}</li>
                <li>{t("rules.howToSublist2")}</li>
                <li>{t("rules.howToSublist3")}</li>
              </ol>
            </li>
          </ol>
          <div className="rules_img_cont">
            <img src={tabelaBrojevaIUloga} alt="Tabela Brojeva i Uloga" />
            <span>{t("rules.howToImage1")}</span>
          </div>
          <div className="rules_img_cont">
            <img src={pokretanjeIzvlacenja} alt="Pokretanje Izvlacenja" />
            <span>{t("rules.howToImage2")}</span>
          </div>
          <div className="rules_img_cont">
            <img src={infoODobitku} alt="Informacije o dobitku" />
            <span>{t("rules.howToImage3")}</span>
          </div>
          <p>{t("rules.howToParagraph2")}</p>
          <ol>
            <li>{t("rules.howToList4")}</li>
            <li>{t("rules.howToList5")}</li>
            <li>{t("rules.howToList6")}</li>
            <li>
              {t("rules.howToList7")}
              <ol>
                <li>{t("rules.howToSublist4")}</li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
    </div>,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    document.getElementById("overlay-root")!
  );
};

export default ModalMessage;
